// extracted by mini-css-extract-plugin
export default {"blue":"styles_blue__oboPx","yellow":"styles_yellow__GU4jP","container":"styles_container__hm+CE","button":"styles_button__3Mpz1"};